/**
 * @enum {string} OpenPlatformCurrentModeConst
 * @description 开发平台当前环境模式的常量枚举
 */
export const enum OpenPlatformCurrentModeConst {
  /** 生产环境 */
  Production = 'production',
  /** 测试环境 */
  Test = 'test',
  /** 开发环境 */
  Development = 'development'
}
